import { withFormik } from 'formik';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import { fromImmutable } from '../../libs/immutable-transformer';
import '../../styles/vendor/react-checkbox-tree.css';
import BasicInput from './fields/BasicInput';
import BasicSelect from './fields/BasicSelect';
import CheckboxList from './fields/CheckboxList';
import CustomDatePicker from './fields/CustomDatePicker';
import CustomTimePicker from './fields/CustomTimePicker';
import WrappedColorPicker from './fields/WrappedColorPicker';

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.types = [
      {
        title: 'Build / Break',
        value: 'buildbreak',
        defaultColor: '#716aca',
      },
      {
        title: 'Camping',
        value: 'camping',
        defaultColor: '#00C5E2',
      },
      {
        title: 'Event',
        value: 'event',
        defaultColor: '#f4516c',
      },
    ];

    //this._handleRoleChange = this._handleRoleChange.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    period: PropTypes.object,
    setValues: PropTypes.func,
    isCreating: PropTypes.bool,
    dates: PropTypes.object,
    closeModal: PropTypes.func,
    isUpdating: PropTypes.bool,
    isDeleting: PropTypes.bool,
    onDelete: PropTypes.func,
    zones: PropTypes.array,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { period } = nextProps;
    const currentProps = this.props;

    if (currentProps.period !== period && period) {
      // Click on event and open modal
      const start = moment.utc(period.startsAt).utcOffset(120);
      const end = moment.utc(period.endsAt).utcOffset(120);
      const zoneIds = period.zones
        ? fromImmutable(period.zones.filter((zone) => zone.optional === 0).map((zone) => zone.id))
        : [];
      const optionalZoneIds = period.zones
        ? fromImmutable(period.zones.filter((zone) => zone.optional === 1).map((zone) => zone.id))
        : [];

      currentProps.setFieldValue('name', period.name);
      currentProps.setFieldValue('id', period.id);
      currentProps.setFieldValue('type', period.type);
      currentProps.setFieldValue('start_date', start);
      currentProps.setFieldValue('end_date', end);
      currentProps.setFieldValue('end_time', end);
      currentProps.setFieldValue('start_time', start);
      currentProps.setFieldValue('color', period.color);
      currentProps.setFieldValue('zoneIds', zoneIds);
      currentProps.setFieldValue('optionalZoneIds', optionalZoneIds);
    } else if (currentProps.period !== period && !period) {
      // Close modal
      currentProps.resetForm();
    }

    // cancel and reopen create with other selection
    if (currentProps.dates !== nextProps.dates) {
      currentProps.setFieldValue('start_date', nextProps.dates.start);
      currentProps.setFieldValue('end_date', nextProps.dates.end);
    }

    // api call is done
    if (
      (currentProps.isCreating && !nextProps.isCreating) ||
      (currentProps.isUpdating && !nextProps.isUpdating) ||
      (currentProps.isDeleting && !nextProps.isDeleting)
    ) {
      currentProps.resetForm();
    }
  }

  render() {
    const props = this.props;
    const { zones } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="modal-body">
          <input type="hidden" name="id" />
          <BasicInput {...props} name="name" type="text" label="Name" />

          <div className="form-group m-form__group">
            <div className="row">
              <div className="col-md-10">
                <BasicSelect
                  {...props}
                  name="type"
                  label="Type"
                  options={this.types}
                  placeholder="Type"
                  onChange={(e) => {
                    const color = this.types.filter((item) => item.value === e.target.value)[0].defaultColor;
                    props.setFieldValue('color', color);
                  }}
                />
              </div>
              <div className="col-md-2">
                <WrappedColorPicker {...props} name="color" label="Color" />
              </div>
            </div>
          </div>

          <div className="form-group m-form__group">
            <div className="row">
              <div className="col-md-3">
                <CustomDatePicker {...props} name="start_date" label="Start Date" />
              </div>
              <div className="col-md-3">
                <CustomTimePicker {...props} name="start_time" type="time" label="Start Time" />
              </div>
              <div className="col-md-3">
                <CustomDatePicker {...props} name="end_date" label="End Date" />
              </div>
              <div className="col-md-3">
                <CustomTimePicker {...props} name="end_time" type="time" label="End Time" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <CheckboxList
                label={'Required Zones'}
                {...props}
                name="zoneIds"
                options={zones.map((zone) => {
                  return { value: zone.id, title: zone.name };
                })}
              />
            </div>
            <div className="col-md-6">
              <CheckboxList
                label={'Optional Zones'}
                {...props}
                name="optionalZoneIds"
                options={zones.map((zone) => {
                  return { value: zone.id, title: zone.name };
                })}
              />
            </div>
          </div>
        </div>

        <div className="modal-footer">
          {!props.period && [
            <button
              key="1"
              className={
                'btn m-btn btn-primary' +
                (props.isSubmitting ? ' m-btn--custom m-loader m-loader--light m-loader--left' : '')
              }
              disabled={props.isSubmitting}
            >
              Create
            </button>,

            <span key="2" className="m--margin-left-10">
              or{' '}
              <button className="btn btn-link" onClick={this.props.closeModal}>
                Cancel
              </button>
            </span>,
          ]}

          {props.period && [
            <div className="mr-auto">
              <button
                type="button"
                key="delete"
                className="btn btn-danger m-btn m-btn--icon mr-auto"
                onClick={() => this.props.onDelete(props.period.id)}
              >
                <span>
                  <i className="la la-trash" />
                  <span>Delete</span>
                </span>
              </button>
              <a
                href={`/admin/periods/${props.period.id}/wristband`}
                className="btn btn-outline-primary m-btn m-btn--icon ml-4"
              >
                Wristband Templates
              </a>
            </div>,
            <button
              key="1"
              className={
                'btn m-btn btn-primary' +
                (props.isSubmitting ? ' m-btn--custom m-loader m-loader--light m-loader--left' : '')
              }
              disabled={props.isSubmitting}
            >
              Update
            </button>,

            <span key="2" className="m--margin-left-10">
              or{' '}
              <button className="btn btn-link" type="button" onClick={this.props.closeModal}>
                Cancel
              </button>
            </span>,
          ]}
        </div>
      </form>
    );
  }
}

const PeriodForm = withFormik({
  mapPropsToValues: (props) => {
    let values = {
      name: '',
      id: null,
      type: '',
      start_date: undefined,
      end_date: undefined,
      end_time: moment.utc().hours(4).minutes(0).seconds(0).utcOffset(120),
      start_time: moment.utc().hours(4).minutes(0).seconds(0).utcOffset(120),
      color: '#FFFFFF',
      zoneIds: [],
      optionalZoneIds: [],
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === '') {
      errors.name = 'required';
    }

    if (!values.type || values.type === '') {
      errors.type = 'required';
    }

    if (!values.start_time || values.start_time === '') {
      errors.start_time = 'required';
    }

    if (!values.start_date || values.start_date === '') {
      errors.start_date = 'required';
    }

    if (!values.end_time || values.end_time === '') {
      errors.end_time = 'required';
    }

    if (!values.end_date || values.end_date === '') {
      errors.end_date = 'required';
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(InnerForm);

export default PeriodForm;
